import { IMAGE_HOST_URL } from '../constants/image';

export const getStaticFileURL = (image: string) => `${IMAGE_HOST_URL}${image}`;
